var _path, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2289,
    height: 2130,
    viewBox: "0 0 2289 2130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#185c37",
    stroke: "none",
    d: "M 1437.75 1011.75 L 532.5 852 L 532.5 2032.392944 C 532.5 2086.300049 576.200012 2130 630.106995 2130 L 630.106995 2130 L 2192.143066 2130 C 2246.050049 2130 2289.75 2086.300049 2289.75 2032.392944 L 2289.75 2032.392944 L 2289.75 1597.5 L 1437.75 1011.75 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#21a366",
    stroke: "none",
    d: "M 1437.75 0 L 630.106995 0 C 576.200012 0 532.5 43.699951 532.5 97.607056 C 532.5 97.607056 532.5 97.607056 532.5 97.607056 L 532.5 532.5 L 1437.75 1065 L 1917 1224.75 L 2289.75 1065 L 2289.75 532.5 L 1437.75 0 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#107c41",
    stroke: "none",
    d: "M 532.5 532.5 L 1437.75 532.5 L 1437.75 1065 L 532.5 1065 L 532.5 532.5 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 1180.392944 426 L 532.5 426 L 532.5 1757.25 L 1180.392944 1757.25 C 1234.227051 1757.074951 1277.824951 1713.477051 1278 1659.642944 L 1278 523.606934 C 1277.824951 469.772949 1234.227051 426.175049 1180.392944 426 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1127.142944 479.25 L 532.5 479.25 L 532.5 1810.5 L 1127.142944 1810.5 C 1180.977051 1810.324951 1224.574951 1766.727051 1224.75 1712.892944 L 1224.75 576.856934 C 1224.574951 523.022949 1180.977051 479.425049 1127.142944 479.25 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1127.142944 479.25 L 532.5 479.25 L 532.5 1704 L 1127.142944 1704 C 1180.977051 1703.824951 1224.574951 1660.227051 1224.75 1606.392944 L 1224.75 576.856934 C 1224.574951 523.022949 1180.977051 479.425049 1127.142944 479.25 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 1073.892944 479.25 L 532.5 479.25 L 532.5 1704 L 1073.892944 1704 C 1127.727051 1703.824951 1171.324951 1660.227051 1171.5 1606.392944 L 1171.5 576.856934 C 1171.324951 523.022949 1127.727051 479.425049 1073.892944 479.25 Z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1",
    x1: 203.5132,
    y1: 402.9817,
    x2: 967.9868,
    y2: 1727.0183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#18884f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631",
    stopOpacity: 1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "url(#linearGradient1)",
    stroke: "none",
    d: "M 97.607002 479.25 L 1073.891968 479.25 C 1127.79895 479.25 1171.499023 522.949951 1171.499023 576.856934 L 1171.499023 1553.141968 C 1171.499023 1607.04895 1127.79895 1650.749023 1073.891968 1650.749023 L 97.607002 1650.749023 C 43.700001 1650.75 0 1607.050049 0 1553.142944 L 0 576.856934 C 0 522.949951 43.700001 479.25 97.607002 479.25 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "#ffffff",
    stroke: "none",
    d: "M 302.299988 1382.264038 L 507.631989 1064.094971 L 319.5 747.682983 L 470.835999 747.682983 L 573.502014 950.032959 C 582.981018 969.255981 589.47699 983.526978 592.992004 992.952026 L 594.322998 992.952026 C 601.067993 977.615967 608.16803 962.723999 615.622986 948.275024 L 725.370972 747.790039 L 864.299988 747.790039 L 671.375 1062.338013 L 869.200012 1382.262939 L 721.377991 1382.262939 L 602.789978 1160.157959 C 597.203979 1150.708008 592.463989 1140.781982 588.625977 1130.498047 L 586.869019 1130.498047 C 583.39502 1140.572998 578.786011 1150.219971 573.130005 1159.253052 L 451.028015 1382.264038 L 302.299988 1382.264038 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "#33c481",
    stroke: "none",
    d: "M 2192.143066 0 L 1437.75 0 L 1437.75 532.5 L 2289.75 532.5 L 2289.75 97.607056 C 2289.75 43.699951 2246.050049 0 2192.143066 0 L 2192.143066 0 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fill: "#107c41",
    stroke: "none",
    d: "M 1437.75 1065 L 2289.75 1065 L 2289.75 1597.5 L 1437.75 1597.5 L 1437.75 1065 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.805ffeb62ac5770d512044e911222b74.svg";
export { ForwardRef as ReactComponent };